import React from 'react'
import { string, number, bool, object } from 'prop-types'
import { soompi } from 'scripts/api/SoompiApi'
import {getLang} from 'shared/i18n/react'

export default function Topic(Component) {
  return class extends React.Component {
    constructor(props) {
      super(props)
      this.state = { topics: { posts: this.props.placeHolders || [] } }
      this.getTopic = null
      this.lang = getLang()
    }

    static propTypes = {
      id: string.isRequired,
      type: string.isRequired,
      page: number.isRequired,
      limit: number.isRequired,
      title: string,
      linktype: string,
      size: number,
      links: object,
      showPlayBtn: bool
    }

    componentDidMount() {
      const { id, type, page, limit } = this.props
      this.getTopic = soompi.setLanguage(this.lang).getTopic(type)({id}, {perPage: limit, page: page})
      this.getTopic.promise.then((topic) => {
        this.setState({topics: {posts: topic.results || []}, done: true})
      })
    }

    componentWillUnmount() {
      if (this.getTopic) {
        this.getTopic.cancel()
      }
    }

    render() {
      const { posts } = this.state.topics
      if (posts && posts.length === 0) { return null }
      const { slug } = this.props
      const settings = {
        data: posts,
        slug: slug || '/',
        size: this.props.size || 4,
        badgeDate: true,
        titleOnly: true,
        titleArrow: true
      }

      return (
        <Component {...this.state} {...this.props} {...settings} />
      )
    }
  }
}



// WEBPACK FOOTER //
// ./assets/js/components/content/Topic.jsx